/**
 * @license lucide v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import defaultAttributes from '../defaultAttributes.js';

const MoveDiagonal2 = [
  "svg",
  defaultAttributes,
  [
    ["path", { d: "M19 13v6h-6" }],
    ["path", { d: "M5 11V5h6" }],
    ["path", { d: "m5 5 14 14" }]
  ]
];

export { MoveDiagonal2 as default };
//# sourceMappingURL=move-diagonal-2.js.map
